import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const westernUnionAPI = async (formdata, serviceName, additionalParams) => {
    const sessionData = getSessionData();
    try {
      const data = JSON.stringify({
        svc: "WesternUnion",
        pid: serviceName,
        dat: {
          ...formdata,
          ...sessionData,
          ...additionalParams
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      const sessionActive = checkSessionIsActive(response.data);
      if (!sessionActive) {
        resetSession();
      }
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

export const getWesternUnionErrorMessage = (response) => {
  let errorMessage = '';
  const errorPath = response?.payload?.payload?.body?.issues;
  if (errorPath) {
    const field = errorPath.field;
    if (field === 'sender.id1.number') {
      errorMessage += 'Sender ID Number is invalid.';
    } else if (field.includes('sender.address')) {
      errorMessage += 'Sender Address is invalid';
    } else if (field.includes('sender.contactNumber') || field.includes('sender.mobileNumber')) {
      errorMessage += 'Sender Phone Number is invalid.';
    } else if (field.includes('receiver.address')) {
      errorMessage += 'Receiver address is invalid.';
    } else if (field.includes('receiver.name')) {
      errorMessage += 'Receiver name is invalid.';
    } else {
      errorMessage += `${field} is invalid`;
    }
  }

  const externalAPIResponse = response?.payload?.externalAPIResponse;
  if (externalAPIResponse?.errorCode) {
    errorMessage += `${externalAPIResponse.errorCode}: ${externalAPIResponse.message}`;
  }

  const bodyErrorMessage = response.payload?.body || response?.payload?.payload?.body;
  if (bodyErrorMessage?.errorCode) {
    errorMessage += `${bodyErrorMessage.errorCode}: ${bodyErrorMessage.message}`;
  }

  return errorMessage;
}